import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import * as Locales from 'date-fns/locale';
import i18next from 'i18next';
import { head } from 'lodash-es';

import { FORMAT_MONTH } from '@modules/core/composables/datetime/constants';
import { isDate, isString } from '@utils/guards';

export interface FormatDateComposable {
  formatDate(date: string | Date, dateFormat?: string, locale?: string): string;
}

export default function useFormatDate(): FormatDateComposable {
  const formatDate = (date: string | Date, dateFormat = 'Pp', locale: string = i18next.language): string => {
    if (!date)
      return '';

    const getLocale = (innerLocale: string): Locale => {
      const fullLocale = (innerLocale.replace('_', '') || 'enUS') as keyof typeof Locales;
      const shortLocale = (head(innerLocale.split('_')) || 'enUS') as keyof typeof Locales;

      if (fullLocale in Locales) {
        return Locales[fullLocale];
      }

      if (shortLocale in Locales) {
        return Locales[shortLocale];
      }

      return Locales.enUS;
    };

    if (isString(date)) {
      if (dateFormat === FORMAT_MONTH) {
        const utcDate = utcToZonedTime(new Date(date), 'UTC');

        return format(utcDate, dateFormat, { locale: getLocale(locale) });
      }
      return format(new Date(date), dateFormat, { locale: getLocale(locale) });
    }

    return isDate(date) ? format(date, dateFormat, { locale: getLocale(locale) }) : '';
  };

  return { formatDate };
}
